import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const setWhatsappProfile = async (selectedDomain: string, params: any): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop-whatsapp-profile',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        params,
    });
}